import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { BaseComponent } from '../../base.component';
import { User } from '../../../services/data/users/user.class';
import { Space } from '../../../services/data/spaces/space.class';
import { ApplicationService } from '../../../services/app.service';
import { IDisplayIcon } from '../../utilities/types.utilities';

type HeaderBarEvent = 'test' | 'help' | 'refresh';

@Component({
    selector: 'header-bar',
    templateUrl: './header-bar.component.html',
    styleUrls: ['./header-bar.component.scss'],
    animations: [
        trigger('show', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translate(100%, -100%) scale(0)' }),
                animate(200, style({ opacity: 1, transform: 'translate(0%, 0%) scale(1)' })),
            ]),
            transition(':leave', [style({ opacity: 1 }), animate(200, style({ opacity: 0 }))]),
        ]),
    ],
})
export class HeaderBarComponent extends BaseComponent implements OnInit {
    /** User from which to display information */
    @Input() public user: User;
    /** Room from which to display information */
    @Input() public space: Space;
    /** Whether user can test audio & video settings */
    @Input('canTest') public can_test: boolean;
    /** Emitter for button events on component */
    @Output() public event = new EventEmitter<HeaderBarEvent>();
    /** Display icon metadata for the application logo */
    public logo: IDisplayIcon;
    /** Show mobile menu tooltip */
    public show_menu: boolean;

    constructor(private service: ApplicationService) {
        super();
    }

    public ngOnInit(): void {
        if (!this.service.is_ready) {
            return this.timeout('init', () => this.ngOnInit());
        }
        this.logo = this.service.setting('app.logo');
    }

    public get is_uat(): boolean {
        return this.service.setting('env') === 'staging';
    }

    /**
     * Emit header bar event
     * @param type Type of event
     */
    public emit(type: HeaderBarEvent) {
        this.event.emit(type);
        this.show_menu = false;
    }

    /**
     * Cancel closing the tooltip menu
     */
    public cancelClose() {
        this.clearTimeout('close_menu');
    }

    /**
     * Close the tooltip menu
     */
    public closeMenu() {
        this.timeout('close_menu', () => (this.show_menu = false));
    }

    /** Open help link in a new window */
    public openLink(): void {
        if (this.space.help_button) {
            window.open(this.space.help_button, '_blank');
        }
    }

    public refresh(): void {
        location.reload();
    }
}
